import React, { useState } from "react";
import "./Navbar.css";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import TalkButton from "../TalkButton";

const NavHeader = ({isTransparent = false}) => {

  const [nav, setNav] = useState(false);

  const addBackground = () => {
    if (window.scrollY > window.innerHeight) {
      setNav(true);
    } else {
      setNav(false);
    }
  };
  window.addEventListener("scroll", addBackground);


  return (
    <div className={isTransparent ? nav ?"navbar navbar-transparent active":"navbar navbar-transparent ":"navbar"}>
      <Link to="/">
        <img src={logo} alt="logo" />
      </Link>
      <div className="navbar__content">
        <Link to="/about">
          {/* <p className="">About</p> */}
          <TalkButton title="About" />
        </Link>
        <Link to="/work">
          {/* <p>Work</p> */}
          <TalkButton title="Work" />
        </Link>
        <Link to="/blog">
          {/* <p>Blog</p> */}
          <TalkButton title="Blog" />
        </Link>
      </div>
    </div>
  );
};

export default NavHeader;
